<template>
 <ion-page>
		<spot-header :title="pageTitle + (!tablesData || !tablesData.currentProject ? '' : tablesData.currentProject.name) + ' - ' + (!tablesData || !tablesData.currentLocation ? '' : tablesData.currentLocation.name)" :canGoHome="false" :canGoBack="true" @pressedGoHome="$router.push('/home')" @pressedGoBack="exitProject"></spot-header>

		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-progress-bar type="indeterminate" v-if="!isActive"></ion-progress-bar>
			<div id="actionArea" v-else>
				<web-socket-reader crReplacedChar="|" @readedBarcode="onReadedBarcode" @readedTag="onReadedTag" @readerError="onReaderError"></web-socket-reader>
				<ion-item>
					<spot-input
						:ref="fields[field.search].name"
						:label="fields[field.search].text"
						:allignLabel="fields[field.search].allignLabel"
						:required="fields[field.search].required"
						:placeholder="fields[field.search].placeholder"
						:enabled="true"
						:value="fields[field.search].value"
						:type="fields[field.search].inputType"
						:clearInput="true"
						@textChanged="changedSearch">
					</spot-input>
					<!--
					<ion-button size="default" slot="end" disabled="true" @click="createNewProjectRow">
						<ion-icon :icon="duplicate" slot="start" size="default"></ion-icon>
						{{ newItemText }}
					</ion-button>
					-->
				</ion-item>
				<ion-progress-bar type="indeterminate" v-if="!tablesData.projectRows"></ion-progress-bar>
				<EasyDataTable
					:headers="headers"
					:items="tablesData.projectRows"
					:sort-by="sortBy"
					:sort-type="sortType"
					:search-field="searchFields"
					:search-value="fields[field.search].value"
					:empty-message="noItemsText"
					:body-row-class-name="bodyRowClassNameFunction"
					@click-row="editExistingProjectRow($event)"
					multi-sort> <!-- :body-item-class-name="bodyItemClassNameFunction" show-index alternating @click-row="createNewProjectRow" -->
					<!--
					<template #item-actions="projectRow">
						<ion-button disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="showExistingProjectRow(projectRow)">
							<ion-icon :icon="reader" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button :color="projectRow.quantity == item.quantity ? 'success' : (projectRow.quantity == 0 ? 'danger' : (projectRow.quantity < item.quantity ? 'warning' : 'tertiary'))" disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="editExistingProjectRow(projectRow)">
							<ion-icon :icon="brush" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button disabled=true fill="outline" shape="round" size="small" slot="icon-only" @click="deleteExistingProjectRow(projectRow)">
							<ion-icon :icon="trash" slot="end" size="small"></ion-icon>
						</ion-button>
					</template>
					-->
					<template #expand="element">
						{{element.item.description}}
					</template>
				</EasyDataTable>
				<ion-modal ref="modal" backdrop-dismiss="false" :is-open="isOpenModal" @didDismiss="modalDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ modalTitle }}</ion-title>
						</ion-toolbar>
						<div lines="none" v-for="field in visibleItemContents" :key="field.id" class="no-pad">
							<spot-input
								v-if="(field.inputType == 'text' || field.inputType == 'number')"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="field.enabled"
								:validationState="field.validationState"
								:furtherInfo="field.furtherInfo"
								:value="field.value"
								:type="field.inputType"
								@textChanged="changedTextField(field.id, $event)">
							</spot-input>
							<ion-textarea
								v-if="field.inputType == 'area'"
								:ref="field.name"
								:placeholder="getPlaceHolder(field)"
								:required="field.required"
								:disabled="!field.enabled"
								:auto-grow="true"
								:value="field.value">
							</ion-textarea>
							<spot-checkbox
								v-if="field.inputType == 'check'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:enabled="modalReadOnly == true ? false : true"
								:validationState="field.validationState"
								:value="field.value"
								@checkboxChanged="changedCheckboxField(field.id, $event)"
								@focus="$event.target.select()">
							</spot-checkbox>
							<spot-date
								v-if="field.inputType == 'datetime'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:enabled="field.enabled"
								:validationState="field.validationState"
								:value="field.value"
								color="primary"
								:doneText="confirmText"
								:cancelText="undoText"
								@dateChanged="changedDateField(field.id, $event)">
							</spot-date>
						</div>
						<div class="flex-row-center-container">
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeModal(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="!isEmptyRequiredFields && modalReadOnly == false"
								:expand="null"
								:text="confirmText"
								@clicked="closeModal(true)">
							</spot-button>
						</div>
					</ion-content>
				</ion-modal>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.debug">
				<div>Test Area</div>
				<spot-button
					fill="outline"
					size="large"
					color="primary"
					:enabled="true"
					text="Simulate Scan"
					@clicked="onReadedBarcode('1111111111111','barcode')">
				</spot-button>
				<div v-for="field in fields" :key="field.id">
					{{ field.name }} = {{ field.value }}
				</div>
			</div>
		</ion-content>

 </ion-page>
</template>

<style scoped>
	ion-modal {
		--height: 80%;
		--width: 90%;
		--border-radius: 16px;
		--box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	}
	ion-modal::part(backdrop) {
		background: var(--ion-color-medium);
		opacity: 1;
	}
	ion-modal ion-toolbar {
		--background: var(--ion-color-primary);
		--color: white;
	}
	ion-textarea {
		font-size: 12px;
	}
	.flex-row-center-container {
		margin-top: 0.2em;
		text-align: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.no-pad {
		margin-top: 0px;
		margin-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	*:deep(ion-checkbox) {
		margin-top: 0px;
		margin-bottom: 0px;
	}
</style>
<style>
	.empty-row  {
		--easy-table-body-row-background-color: var(--ion-color-danger); /*#f56c6c;*/
	}
	.partial-row  {
		--easy-table-body-row-background-color: var(--ion-color-warning); /*#ddc229;*/
	}
	.completed-row  {
		--easy-table-body-row-background-color: var(--ion-color-success); /*#67c23a;*/
	}
	.exceeded-row  {
		--easy-table-body-row-background-color: var(--ion-color-tertiary); /*#0d9de0;*/
	}
	.prominence-column {
		font-size: 20px;
	}
</style>

<script>
import { /*IonButton, */IonContent, /*IonIcon, */IonItem, IonModal, IonPage, IonProgressBar, IonTextarea, IonTitle, IonToolbar } from '@ionic/vue';
// import { brush, duplicate, reader, trash } from 'ionicons/icons';
import { defineComponent } from 'vue';
import SpotButton from '../components/SpotButton.vue';
import SpotCheckbox from '../components/SpotCheckbox.vue';
import SpotInput from '../components/SpotInput.vue';
import SpotDate from '../components/SpotDate.vue';
import SpotHeader from "../components/SpotHeader.vue";
import WebSocketReader from '../components/WebSocketReader.vue';
import { checkUserSession, confirmYesNo /*, insertValue*/, settings, showMsgError, showMsgInfo, showMsgWarning, writeLog } from '../plugins/common.js';
import { getBarcodeToSearch, getDateOnly, getItemTracking } from '../plugins/gs1Ai.js';
import { createProjectRow, deleteProjectRow, getLocation, getOrCreateItemSerialId, searchItemProjectRow, searchItemSerial, getProject, getProjectRow, searchItem, searchProjectRows, tablesData, updateProjectRow, updateProject } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "ManageFreeInventory",
		props: {
			pageTitle: { type: String, default: 'Gestisci ' }, //'Gestisci Inventario'
			noItemsText: { type: String, default: 'Nessun Articolo presente' },
			newItemText: { type: String, default: 'Nuovo Articolo' },
			editItemText: { type: String, default: 'Modifica Articolo'}, //'Modifica Articolo: '
			showItemText: { type: String, default: 'Visualizza Articolo'}, //'Visualizza Articolo: '
			undoText: { type: String, default: 'Annulla' },
			confirmText: { type: String, default: 'Conferma' },
			unselected: { type: String, default: 'Nessuno' },
			selectedText: { type: String, default: 'Selezionato' },
			deselectText: { type: String, default: 'annulla' },
			selectText: { type: String, default: 'seleziona' },
			messageSearchItemTitle: { type: String, default: 'Ricerca Articolo' },
			messageSearchItemNotFound: { type: String, default: 'Articolo non trovato!' },
			messageTitleCheckTAG: { type: String, default: 'Controllo TAG' },
			warnMultipleTAG: { type: String, default: 'Letto più di un TAG. Avvicinarsi solo al TAG da leggere e riprovare' },
			warnInavlidTAG: { type: String, default: 'TAG letto solo in parte. Riprovare a leggere' },
			confirmDeleteTitle: { type: String, default: 'Conferma Cancellazione' },
			confirmDeleteMessage: { type: String, default: 'Confermi la cancellazione dell\'articolo corrente?' },
			messageTitleReader: { type: String, default: 'Lettura Barcode/TAG' },
			errorReadingReader: { type: String, default: 'Errore nella lettura del barcode/tag' },
			messageTitleGs1: { type: String, default: 'Controllo GS1' },
			warnInvalidGs1: { type: String, default: 'Il codice letto non è un GS1 valido o non contiene il GTIN (01)!' + '<br>' + 'Codice letto: ' },
			lotCodeText: { type: String, default: 'Codice Lotto' },
			serialCodeText: { type: String, default: 'Codice Seriale' },
			messageTitleSerial: { type: String, default: 'Lotto / Seriale' },
			errorSerialNotSaved: { type: String, default: 'Impossibile recuperare o creare il Lotto/Seriale dell\'articolo!' },
			messageTitleInsert: { type: String, default: "Inserimento Nuovo Collo" },
			confirmExitTitle: { type: String, default: 'Conferma Uscita' },
			confirmExitMessage: { type: String, default: 'Confermi l\'uscita dalla rilevazione anche se non sono stati inseriti tutti i dati?' },
			messageTitleInvalidQuantity: { type: String, default: "Quantità non valida" },
			warnInavlidQuantity: { type: String, default: 'La Quantità inserita sommata alla Quantità rilevata in precedenza è superiore alla Quantità Prevista!' },
		},
		components: {
			IonPage,
			IonContent,
			IonProgressBar,
			IonItem,
			// IonButton,
			// IonIcon,
			IonModal,
			IonToolbar,
			IonTitle,
			IonTextarea,
			SpotHeader,
			SpotInput,
			SpotCheckbox,
			SpotDate,
			SpotButton,
			WebSocketReader,
		},
		data: () => ({
			isActive: null,
			field: {
				search: 0,
			},
			fields: [
				{ id: 0, name: 'search', text: 'Cerca: ', allignLabel: true, placeholder: 'Cerca Articolo', inputType: 'text', defaultValue: '', value: null, required: false, refField: null },
			],
			searchFields: ['item.code','item.description'],
			headers: [
				// { text: 'Ubicazione', value: 'location.name', sortable: true },
				{ text: 'Articolo', value: 'item.code', sortable: true },
				{ text: 'UM', value: 'item.measure_unit.name', sortable: false },
				{ text: 'Previsti', value: 'item.quantity', sortable: false },
				{ text: 'Rilevati', value: 'quantity', sortable: false },
				// { text: 'Azioni', value: 'actions', sortable: false }
			],
			sortType: ['asc', 'asc'],
			sortBy: ['location.name','item.code'],
			itemContent: {
				id: 0,
				code: 1,
				description: 2,
				expectedQuantity: 3,
				quantity: 4,
				lotSerial: 5,
				expiryDate: 6,
			},
			itemContents: [
				{ id: 0, name: 'id', text: 'Id', enabled: false, allignLabel: true, placeholder: 'Inserisci ID', inputType: "number", defaultValue: null, value: null, required: false, validationState: null },
				{ id: 1, name: 'code', text: 'Articolo', enabled: false, allignLabel: true, placeholder: 'Inserisci Codice Articolo', inputType: 'text', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 2, name: 'description', text: 'Descrizione', enabled: false, allignLabel: false, placeholder: 'Inserisci Descrizione', inputType: 'area', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 3, name: 'expectedQuantity', enabled: false, allignLabel: false, text: 'Quantità Prevista', placeholder: 'Inserisci Quantità Prevista', inputType: 'number', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 4, name: 'quantity', text: 'Quantità', enabled: true, allignLabel: true, placeholder: 'Inserisci Quantità', inputType: 'number',  defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 5, name: 'lotSerial', text: 'Codice Lotto', enabled: false, visible: false, allignLabel: true, placeholder: 'Inserisci Codice', inputType: 'text', defaultValue: null, value: null, required: false, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 6, name: 'expiryDate', text: 'Data di Scadenza', enabled: false, visible: false, allignLabel: true, placeholder: 'Inserisci Data di Scadenza', inputType: 'datetime', defaultValue: null, value: null, required: false, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
			],
			isOpenModal: false,
			modalTitle: null,
			modalReadOnly: null,
			actionDbCreate: null,
			isFree: null,
			isPicking: null,
			isRevision: null,
			isLocked: null,
			projectId: null,
			locationId: null,
			lastBarcode: null,
			lastGs1: null,
			lastTag: null,
			itemTracking: null,
			isTrackedNewRow: false, //true = new row of an item with lots/serials: while the operator fills lot/serial and expiry date, the existing row is searched
			newRowQuantity: null,
			trackedRowTimer: null,
			trackedRowRequest: 0,
			forceSerialQuantity: false, //true = Quantity forced to 1 for items with serials; false = Free quantity (some suppliers use SERIAL (21) as lot)
			assignRemaingQuantity: false,
			allowExceededQuantity: true,
			// brush,
			// duplicate,
			// reader,
			// trash,
			settings,
			checkUserSession,
			confirmYesNo,
			showMsgError,
			showMsgInfo,
			showMsgWarning,
			writeLog,
			getBarcodeToSearch,
			getDateOnly,
			getItemTracking,
			getOrCreateItemSerialId,
			searchItemProjectRow,
			searchItemSerial,
			getLocation,
			getProject,
			getProjectRow,
			searchItem,
			searchProjectRows,
			createProjectRow,
			updateProjectRow,
			deleteProjectRow,
			updateProject,
			tablesData,
		}),
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			this.isActive = true;
		},
		ionViewWillLeave() {
			this.isOpenModal = false;
			this.isActive = false;
		},
		computed: {
			visibleItemContents() {
				return this.itemContents.filter(element => element.visible != false);
			},
			isEmptyRequiredFields() {
				let ret = false;
				this.itemContents.forEach(element => {if (element.required && !element.value && element.id > 0) ret = true});
				return ret;
			},
			isInventoryClean() {
				let ret = true;
				if (this.tablesData.projectRows && this.tablesData.projectRows.length > 0) ret = false;
				return ret;
			},
			isInventoryFinished() {
				let ret = true;
				this.tablesData.projectRows.forEach(element => {if (element.quantity != element.item.quantity) ret = false});
				return ret;
			},
			checkQuantity() {
				let ret = true;
				if (!this.allowExceededQuantity) {
					if ((parseFloat(this.tablesData.currentProjectRow.quantity) + parseFloat(this.itemContents[this.itemContent.quantity].value)) > parseFloat(this.tablesData.currentProjectRow.item.quantity)) {
						this.showMsgWarning(this.messageTitleInvalidQuantity, this.warnInavlidQuantity);
						ret = false;
					}
				}
				return ret;
			},
		},
		setup() {
			const bodyRowClassNameFunction = (element) => {
				if (parseFloat(element.quantity) == parseFloat(element.item.quantity)) return 'completed-row'
				else if(parseFloat(element.quantity) == parseFloat(0)) return 'empty-row'
				else if(parseFloat(element.quantity) < parseFloat(element.item.quantity)) return 'partial-row'
				else return 'exceeded-row';
			}
			const bodyItemClassNameFunction = (column) => {
				if (column === 'quantity' || column === 'item.quantity') return 'prominence-column';
				else return '';
			};
			return {
				bodyRowClassNameFunction,
				bodyItemClassNameFunction,
			};
		},
		methods: {
			// Settings & StartUp
			getUrlParamsAndQuery() {
				this.isFree = (/true/i).test(this.$route.query.free);
				this.isPicking = (/true/i).test(this.$route.query.picking);
				this.isRevision = (/true/i).test(this.$route.query.revision);
				this.isLocked = (/true/i).test(this.$route.query.locked);
				this.locationId = parseInt(this.$route.query.location);
				this.projectId = this.$route.params.id;
			},
			setDefault() {
				this.fields.forEach(element => element.value = element.defaultValue);
				this.isOpenModal = false;
				this.modalTitle = null;
				this.modalReadOnly = null;
				this.actionDbCreate = null;
				this.lastBarcode = null;
				this.lastGs1 = null;
				this.lastTag = null;
				this.itemTracking = null;
				this.isTrackedNewRow = false;
			},
			getPlaceHolder(element) {
				return ((this.settings.showFieldsPlaceholder) ? (element.required ? element.placeholder : this.unselected ) : '')
			},
			// Database
			async getAllTablesData() {
				await this.getProject(this.projectId);
				await this.getLocation(this.locationId);
				this.tablesData.projectRows = [];
				await this.searchProjectRows(this.projectId, this.locationId);
			},
			async deleteExistingProjectRow(projectRow) {
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeleteMessage)
					.then((data) => { canDelete = data })
				if (canDelete == true) {
					await this.deleteProjectRow(projectRow.id)
				}
			},
			// Actions
			async onReadedBarcode(barcode, type, gs1Data = null) {
				this.writeLog(barcode, type, gs1Data);
				let barcodeToSearch = this.getBarcodeToSearch(barcode, type, gs1Data, this.settings.manageGs1Ai);
				this.lastBarcode = barcodeToSearch.barcode;
				this.lastGs1 = barcodeToSearch.gs1Data;
				if (barcodeToSearch.result == false) {
					this.showMsgWarning(this.messageTitleGs1, this.warnInvalidGs1 + barcode);
					return;
				}
				await this.committedBarcodeInItems();
			},
			async onReadedTag(tag,type) {
				this.lastTag = tag;
				this.writeLog(tag, type);
				await this.committedTag();
			},
			onReaderError(data,error) {
				this.showMsgError(data, error);
				this.showMsgWarning(this.messageTitleReader, this.errorReadingReader);
			},
			changedSearch(value) {
				this.fields[this.field.search].value = value;
			},
			changedTextField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
				if (fieldId == this.itemContent.lotSerial) this.scheduleTrackedRowCheck();
			},
			changedDateField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
				if (fieldId == this.itemContent.expiryDate) this.scheduleTrackedRowCheck();
			},
			scheduleTrackedRowCheck() {
				if (this.isTrackedNewRow != true) return;
				clearTimeout(this.trackedRowTimer);
				this.trackedRowTimer = setTimeout(() => this.checkTrackedProjectRow(), 500);
			},
			async checkTrackedProjectRow() { // If the row of the lot/serial already exists, the popup edits it showing its quantity (replaced on save)
				let request = ++this.trackedRowRequest;
				let tracking = {
					type: this.itemTracking,
					code: this.itemContents[this.itemContent.lotSerial].value,
					expiryDate: (this.itemTracking == 'lot') ? this.getDateOnly(this.itemContents[this.itemContent.expiryDate].value) : null,
				};
				let projectRow = await this.searchTrackedProjectRow(this.tablesData.currentItem, tracking);
				if (request != this.trackedRowRequest || this.isOpenModal == false || this.isTrackedNewRow != true) return; // Fields changed in the meantime or popup closed
				if (projectRow) {
					if (this.actionDbCreate == true) this.newRowQuantity = this.itemContents[this.itemContent.quantity].value;
					this.itemContents[this.itemContent.id].value = projectRow.id;
					this.itemContents[this.itemContent.quantity].value = parseFloat(projectRow.quantity);
					this.itemContents[this.itemContent.expectedQuantity].furtherInfo = ' (già inseriti: ' + parseFloat(projectRow.quantity) + ')';
					this.modalTitle = this.editItemText;
					this.actionDbCreate = false;
				}
				else if (projectRow === null && this.actionDbCreate == false) {
					this.itemContents[this.itemContent.id].value = null;
					this.itemContents[this.itemContent.quantity].value = this.newRowQuantity;
					this.itemContents[this.itemContent.expectedQuantity].furtherInfo = null;
					this.modalTitle = this.newItemText;
					this.actionDbCreate = true;
				}
				this.itemContents[this.itemContent.quantity].validationState = (this.itemContents[this.itemContent.quantity].value == null) ? false : true;
			},
			changedCheckboxField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			assignedSelectField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			resetSelectField(fieldId) {
				this.itemContents[fieldId].value = null;
				this.itemContents[fieldId].validationState = false
			},
			prepareNewRecord(serialId = null) {
				let myRecord = {
					project_rows: {
						project_id: this.projectId, // this.tablesData.currentProject.id
						location_id: this.locationId, // this.tablesData.currentLocation.id
						item_id: this.tablesData.currentItem.id,
						quantity: this.itemContents[this.itemContent.quantity].value,
					}
				};
				if (serialId != null) myRecord.project_rows.serial_id = serialId;
				return myRecord;
			},
			prepareUpdateRecord() {
				let myRecord = {
					project_rows: {
						quantity: this.itemContents[this.itemContent.quantity].value,
					}
				};
				return myRecord;
			},
			updateItemContents(row) {
				Object.getOwnPropertyNames(row).forEach(rowField => {
					this.itemContents.forEach(pageElement => {
						if (rowField == pageElement.name) {
							pageElement.value = row[rowField];
						}
					});
				});
			},
			setItemTrackingContents(item, gs1Data = null) {
				let tracking = this.getItemTracking(item, gs1Data, this.settings.manageGs1Ai);
				let lotSerial = this.itemContents[this.itemContent.lotSerial];
				let expiryDate = this.itemContents[this.itemContent.expiryDate];
				this.itemTracking = tracking.type;
				lotSerial.visible = (tracking.type != null);
				lotSerial.required = lotSerial.visible;
				lotSerial.text = (tracking.type == 'serial') ? this.serialCodeText : this.lotCodeText;
				lotSerial.value = tracking.code;
				lotSerial.enabled = (lotSerial.visible && !tracking.code);
				lotSerial.validationState = (!lotSerial.visible) ? null : !!tracking.code;
				expiryDate.visible = (tracking.type == 'lot');
				expiryDate.required = expiryDate.visible;
				expiryDate.value = tracking.expiryDate;
				expiryDate.enabled = (expiryDate.visible && !tracking.expiryDate);
				expiryDate.validationState = (!expiryDate.visible) ? null : !!tracking.expiryDate;
				if (tracking.type == 'serial' && this.forceSerialQuantity == true) {
					this.itemContents[this.itemContent.quantity].value = 1;
					this.itemContents[this.itemContent.quantity].enabled = false;
				}
				else {
					this.itemContents[this.itemContent.quantity].enabled = true;
				}
			},
			createCustomItemContents(projectRow = null) {
				this.itemContents[this.itemContent.code].value = (!projectRow) ? this.tablesData.currentItem.code : projectRow.item.code
				this.itemContents[this.itemContent.description].value = (!projectRow) ? this.tablesData.currentItem.description : projectRow.item.description
				this.itemContents[this.itemContent.expectedQuantity].value = (!projectRow) ? this.tablesData.currentItem.quantity : projectRow.item.quantity
				this.itemContents[this.itemContent.expectedQuantity].furtherInfo = (!projectRow) ? null : ((projectRow.quantity > 0) ? ' (già inseriti: ' + parseFloat(projectRow.quantity) + ')' : null)
				this.itemContents[this.itemContent.quantity].value = (!this.assignRemaingQuantity)? null : ((!projectRow) ? this.tablesData.currentItem.quantity : (parseFloat(this.tablesData.currentItem.quantity) - parseFloat(projectRow.quantity)))
				//this.itemContents[this.itemContent.quantity].furtherInfo = (!projectRow) ? ' / ' + this.tablesData.currentItem.quantity : ' / ' + (parseFloat(this.tablesData.currentItem.quantity) - parseFloat(projectRow.quantity))
			},
			updateCustomItemContents(row) {
				this.itemContents[this.itemContent.id].value = row.id
				this.itemContents[this.itemContent.code].value = row.item.code
				this.itemContents[this.itemContent.description].value = row.item.description
				this.itemContents[this.itemContent.expectedQuantity].value = parseInt(row.item.quantity)
				this.itemContents[this.itemContent.quantity].value = parseInt(row.quantity)
			},
			async createNewProjectRow(tableRow = null, gs1Data = null) { // gs1Data is null when the item is clicked from the list
				if (!tableRow) {
					this.itemContents.forEach(element => element.value = element.defaultValue);
					this.createCustomItemContents();
					this.setItemTrackingContents(this.tablesData.currentItem, gs1Data);
				}
				else {
					this.tablesData.currentProjectRow = tableRow;
					await this.getProjectRow(tableRow.id);
					this.createCustomItemContents(this.tablesData.currentProjectRow);
					this.setItemTrackingContents(this.tablesData.currentProjectRow.item, gs1Data);
				}
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.newItemText;
				this.actionDbCreate = true;
				this.isTrackedNewRow = (this.itemTracking != null);
				this.newRowQuantity = this.itemContents[this.itemContent.quantity].value;
				this.openModal(false);
			},
			async editExistingProjectRow(projectRow, gs1Data = null) { // gs1Data is passed only when the row of the lot/serial read is found
				this.setItemTrackingContents((!gs1Data) ? null : projectRow.item, gs1Data);
				this.isTrackedNewRow = false;
				this.updateCustomItemContents(projectRow);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.editItemText // + projectRow.item.code;
				this.actionDbCreate = false;
				this.openModal(false);
			},
			async showExistingProjectRow(projectRow) {
				this.setItemTrackingContents(null);
				this.updateCustomItemContents(projectRow);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.showItemText // + projectRow.item.code;
				this.actionDbCreate = false;
				this.openModal(true);
			},
			openModal(isReadOnly) {
				this.modalReadOnly = isReadOnly;
				this.isOpenModal = true;
			},
			async closeModal(saveRecord) {
				let canCloseModal = true;
				if (saveRecord == true) {
					if (this.checkQuantity) {
						if (this.actionDbCreate == true) {
							let serialId = null;
							if (this.itemTracking != null) {
								serialId = await this.getOrCreateItemSerialId(
									this.tablesData.currentItem.id,
									this.itemContents[this.itemContent.lotSerial].value,
									(this.itemTracking == 'lot') ? this.getDateOnly(this.itemContents[this.itemContent.expiryDate].value) : null);
								if (serialId == null) {
									this.showMsgError(this.messageTitleSerial, this.errorSerialNotSaved);
									return;
								}
							}
							let existingProjectRow = null;
							if (serialId != null) {
								existingProjectRow = await this.searchItemProjectRow(this.projectId, this.tablesData.currentItem.id, serialId, this.locationId);
								if (existingProjectRow === false) return;
							}
							if (existingProjectRow) { // Safety check: the row of the lot/serial is normally already found while the operator fills the fields
								await this.updateProjectRow(existingProjectRow.id, this.prepareUpdateRecord())
							}
							else {
								await this.createProjectRow(this.prepareNewRecord(serialId))
							}
						}
						else {
							await this.updateProjectRow(this.itemContents[this.itemContent.id].value, this.prepareUpdateRecord())
						}
					}
					else {
						canCloseModal = false;
					}
				}
				if (canCloseModal) {
					await this.getAllTablesData();
					this.isOpenModal = false;
				}
			},
			async modalDismissed() {
				this.actionDbCreate == null;
			},
			changedBarcode(value) {
				this.lastBarcode = value;
			},
			async committedBarcodeInItems() {
				let foundProjectRow = null;
				if (this.isOpenModal == false) {
					this.tablesData.projectRows.some(element => {
						if (element.item.barcode == this.lastBarcode) {
							foundProjectRow = element;
						}
					});
					let isTrackedRow = false;
					if (foundProjectRow && this.settings.manageGs1Ai == true) { // For items with lots/serials, the row is the one with the same lot/serial
						let tracking = this.getItemTracking(foundProjectRow.item, this.lastGs1, this.settings.manageGs1Ai);
						if (tracking.type != null) {
							isTrackedRow = true;
							foundProjectRow = await this.searchTrackedProjectRow(foundProjectRow.item, tracking);
							if (foundProjectRow === false) return;
						}
					}
					if (!foundProjectRow) {
						this.tablesData.currentItem = null;
						await this.searchItem(null,this.lastBarcode);
						if (!this.tablesData.currentItem) {
							this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound);
						}
						else {
							this.createNewProjectRow(null, this.lastGs1);
						}
					}
					else {
						await this.editExistingProjectRow(foundProjectRow, (isTrackedRow) ? this.lastGs1 : null);
					}
				}
			},
			async searchTrackedProjectRow(item, tracking) { // Returns the row of the item with the lot/serial read, null if not found, false on error
				if (!tracking.code || (tracking.type == 'lot' && !tracking.expiryDate)) return null; // Lot/serial not complete: it will be entered by the operator
				if (await this.searchItemSerial(item.id, tracking.code, tracking.expiryDate) == false) return false;
				if (!this.tablesData.currentSerial) return null;
				return await this.searchItemProjectRow(this.projectId, item.id, this.tablesData.currentSerial.id, this.locationId);
			},
			async committedBarcodeInProjectRows() {
				let foundElement = null;
				if (this.isOpenModal == false) {
					this.tablesData.projectRows.some(element => {
						if (element.item.barcode == this.lastBarcode) {
							foundElement = element;
							return true;
						}
					});
					if (!foundElement) this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound);
					else await this.createNewProjectRow(foundElement);
				}
			},
			changedTag(value) {
				this.lastTag = value;
			},
			async committedTag() {
				let tagElements = this.lastTag.split('|');
				let foundElement = null;

				switch (tagElements.length) {
					case 0:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnInavlidTAG);
						break;
					case 1:
						this.tablesData.projectRows.some(projectRow => {
							if (projectRow.item.code == this.lastTag) {
								foundElement = projectRow;
								return true;
							}
						});
						if (!foundElement) this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound);
						else this.editExistingProjectRow(foundElement);
						break;
					default:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnMultipleTAG);
						break;
				}
			},
			async exitProject() {
				let canExit = true;
				let myRecord = {
					document: {}
				};
				
				if (this.isInventoryFinished == true) {
					// myRecord.document['partial'] = false;
					// myRecord.document['closed'] = true;
					// await this.updateProject(this.projectId, myRecord);
				}
				else {
					if (this.isInventoryClean != true) {
						myRecord.document['partial'] = true;
						await this.updateProject(this.projectId, myRecord);
						await this.confirmYesNo(this.confirmExitTitle, this.confirmExitMessage)
						.then((data) => { canExit = data })
					} else {
						myRecord.document['closed'] = false;
						myRecord.document['partial'] = false;
						await this.updateProject(this.projectId, myRecord);
					}
				}

				if (canExit == true) {
					this.$router.push("/inventory/selection" + "?free=" + this.isFree + "&picking=" + this.isPicking);
				}
			}
		}
	});
</script>
